import React from 'react';
import { ButtonGroup, Button, Grid } from '@mui/material';
import { NetworkType, MemberType } from '../types';

interface NetworkTypeSelectorProps {
    networkType: NetworkType;
    memberType: MemberType;
    onNetworkTypeChange: (type: NetworkType) => void;
    onMemberTypeChange: (type: MemberType) => void;
}

export const NetworkTypeSelector: React.FC<NetworkTypeSelectorProps> = ({
    networkType,
    memberType,
    onNetworkTypeChange,
    onMemberTypeChange
}) => {
    return (
        <Grid container spacing={2} sx={{ mb: 2 }} test-id="vob-network-type-selector">
            <Grid item xs={6}>
                <ButtonGroup test-id="vob-network-type-buttons">
                    <Button
                        test-id="vob-in-network-button"
                        variant={networkType === 'in' ? 'contained' : 'outlined'}
                        onClick={() => onNetworkTypeChange('in')}
                    >
                        In Network
                    </Button>
                    <Button
                        test-id="vob-out-network-button"
                        variant={networkType === 'out' ? 'contained' : 'outlined'}
                        onClick={() => onNetworkTypeChange('out')}
                    >
                        Out of Network
                    </Button>
                </ButtonGroup>
            </Grid>
            <Grid item xs={6}>
                <ButtonGroup test-id="vob-member-type-buttons">
                    <Button
                        test-id="vob-individual-button"
                        variant={memberType === 'individual' ? 'contained' : 'outlined'}
                        onClick={() => onMemberTypeChange('individual')}
                    >
                        Individual
                    </Button>
                    <Button
                        test-id="vob-family-button"
                        variant={memberType === 'family' ? 'contained' : 'outlined'}
                        onClick={() => onMemberTypeChange('family')}
                    >
                        Family
                    </Button>
                </ButtonGroup>
            </Grid>
        </Grid>
    );
}; 